import { ExtraContentImageViewerPage } from '@components/enrollments/courses/course_contents/image_viewer/ExtraContentImageViewerPage'
import { useMediaSize } from '@hooks/useMediaSize'
import { AppLayout } from '@layouts/AppLayout'

export default function ImageViewer() {
  const mediaSize = useMediaSize()
  const isMobile = ['xs', 'sm'].includes(mediaSize)

  return (
    <AppLayout
      backRoute={{
        label: 'Voltar',
      }}
      hasFooter={false}
      hasPaddingBottom={false}
      hasBackButton={isMobile}
    >
      <ExtraContentImageViewerPage />
    </AppLayout>
  )
}
